module.exports = "/_next/static/images/gold-blur-levels-e2a8fd42b0372a16386179915ca24c7b.png";